import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { REGISTERED_ONLY_ROUTES } from './URLs';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideNgxMask } from 'ngx-mask';
import { provideAnimations } from '@angular/platform-browser/animations';
import { spinnerInterceptor } from './core/interceptors/spinner.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // TODO: When fetch is enabled progress is not reported. Investigate if removing 'withFetch()'globally poses a risk.
    // If so provide a dedicated http client with no fetch to the file service
    provideHttpClient(withInterceptors([spinnerInterceptor, authHttpInterceptorFn, authInterceptor])),
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: environment.auth0.audience
      },
      httpInterceptor: {
        allowedList: REGISTERED_ONLY_ROUTES
      },
      useCookiesForTransactions: true
    }),
    provideAngularSvgIcon(),
    provideNgxMask({ thousandSeparator: '.', decimalMarker: ',' }),
    provideAnimations()
  ]
};
